// Short term solution for converting currency to correct prefix, it's planned to return prefix
// in the response body in the future.
export const currencyMap = {
  'US Dollars': 'USD',
  Euro: 'EUR',
  'British Pounds': 'GBP',
  'Canadian Dollars': 'CAD',
};

export const BASE_ARTICLE_ID = 20_000_000;
